<template>
    <rc-alert-local-storage
        icon=""
        :wrap_early="wrap_early"
        :storage_key="storage_key"
        @dismissed="onDismissed"
    >
        <template #title>
            <h3 class="text-h6 mb-3">
                <strong>Coming December 21: Smarter Bulk Messaging </strong>
            </h3>
        </template>

        <div>
            <p>
                We will be adding a new <strong>Review stage</strong> to Bulk Messages that lets you <strong>preview your recipients before you hit Send</strong>. See exactly how many contacts are included, who's filtered out, and why—so you can adjust filters, reach the right audience, and send with confidence.
            </p>

            <p class="mb-0">
                <rc-link
                    href="https://redchirp.com/new-bulk-message-review-step-see-who-youll-reach-before-you-send"
                    text="Watch the Preview Video"
                />
                to see the new Review stage in action!
            </p>
        </div>
    </rc-alert-local-storage>
</template>

<script>
export default {
    name: 'BulkRevampAwareness',

    data() {
        return {
            show_announcement: false,
            has_permanently_dismissed: false,
            storage_key: 'rc-dismissed-bulk-revamp-awareness',
        }
    },

    props: {
        /**
         * In lieu of container queries, which are not well-supported enough yet, this prop
         * can be set to true to make the alert wrap its contents sooner, for use in
         * narrower containers.
         */
        wrap_early: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        const dismissed = localStorage.getItem(this.storage_key);
        this.has_permanently_dismissed = dismissed === 'true';

        if (!this.has_permanently_dismissed) {
            this.show_announcement = true;
            this.$emit('visibility-changed', this.show_announcement);
        }
    },

    methods: {
        onDismissed() {
            this.has_permanently_dismissed = true;
            this.$emit('visibility-changed', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.nudge-up {
    padding-bottom: 2px;
}
</style>